import EmployeesListRightPanel from './EmployeesListRightPanel.component';

export default EmployeesListRightPanel;